import React from "react";
import { formatCellValue, truncateCellValue } from "./utils";

const cellStyle = {
  maxWidth: "30ch",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const renderViewCell = (value) => {
  const fullValue = formatCellValue(value);
  const shortValue = truncateCellValue(fullValue);
  return (
    <td title={fullValue} style={cellStyle}>
      {shortValue}
    </td>
  );
};

const ViewTabContent = ({
  viewCampaignId,
  setViewCampaignId,
  onSearch,
  isFetchingReports,
  viewError,
  viewResult,
  hasSearched,
  onView,
  onEdit,
  onDelete,
}) => (
  <div className="card shadow-sm w-100">
    <div className="card-body p-4">
      <form onSubmit={onSearch} className="mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-6">
            <label htmlFor="view_campaign_id" className="form-label">
              Campaign ID
            </label>
            <input
              id="view_campaign_id"
              type="text"
              className="form-control"
              value={viewCampaignId}
              onChange={(e) => setViewCampaignId(e.target.value)}
              placeholder="Enter campaign ID"
              disabled={isFetchingReports}
            />
          </div>
          <div className="col-md-2">
            <button type="submit" className="btn btn-primary w-100" disabled={isFetchingReports}>
              {isFetchingReports ? "Loading..." : "Search"}
            </button>
          </div>
        </div>
      </form>

      {viewError && <div className="alert alert-danger">{viewError}</div>}

      {!viewError && viewResult.campaign_id && (
        <div className="mb-3">
          <strong>Campaign ID:</strong> {viewResult.campaign_id}{" "}
          <span className="ms-3">
            <strong>Total:</strong> {viewResult.total}
          </span>
        </div>
      )}

      {hasSearched && (
        <div className="table-responsive">
          <table className="table table-hover" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead className="table-light">
              <tr>
                <th>Report Name</th>
                <th>Recipients</th>
                <th>Frequency</th>
                <th>Status</th>
                <th>Time</th>
                <th>Next Execution</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {viewResult.records.map((record) => (
                <tr key={record.id}>
                  {renderViewCell(record.report_name)}
                  {renderViewCell(record.recipients)}
                  {renderViewCell(record.frequency)}
                  {renderViewCell(record.status)}
                  {renderViewCell(record.execution_time)}
                  {renderViewCell(record.next_execution_time)}
                  <td style={{ whiteSpace: "nowrap" }}>
                    <button
                      type="button"
                      className="btn btn-sm btn-action-icon me-2"
                      title="View Report"
                      aria-label="View Report"
                      onClick={() => onView(record)}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                          d="M2 12C4.6 7.8 8 6 12 6C16 6 19.4 7.8 22 12C19.4 16.2 16 18 12 18C8 18 4.6 16.2 2 12Z"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-action-icon me-2"
                      title="Edit Report"
                      aria-label="Edit Report"
                      onClick={() => onEdit(record)}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                          d="M4 20H8L18 10L14 6L4 16V20Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinejoin="round"
                        />
                        <path d="M12 8L16 12" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-action-icon"
                      title="Delete Report"
                      aria-label="Delete Report"
                      onClick={() => onDelete(record)}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M4 7H20" stroke="currentColor" strokeWidth="2" />
                        <path d="M9 7V5H15V7" stroke="currentColor" strokeWidth="2" />
                        <path d="M7 7L8 20H16L17 7" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
              {!isFetchingReports && viewResult.records.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export default ViewTabContent;
